import { useSelector } from 'react-redux'

import {
  SegmentActivationPreference,
  useGetSegmentActivationPreferenceQuery,
  useUpdateSegmentActivationPreferenceMutation,
} from 'api/segments'
import useFlag from 'hooks/useFlag'

type AuthSlice = { auth: { current_merchant_id: number | null } }

export function useSegmentActivationPreference() {
  const autoApproveEnabled = useFlag('mx-segment-auto-approve', false)
  const merchantId = useSelector(
    (state: AuthSlice) => state.auth?.current_merchant_id ?? null
  )

  const { data: preference } = useGetSegmentActivationPreferenceQuery(
    undefined,
    { skip: !autoApproveEnabled || !merchantId }
  )

  const [updatePreferenceMutation] =
    useUpdateSegmentActivationPreferenceMutation()

  const update = async (params: SegmentActivationPreference) =>
    updatePreferenceMutation(params).unwrap()

  return { preference, update }
}
